export default __webpack_public_path__ + "images/8Y.27b6cba.png";